import React, { useContext, useState } from "react";
import { Button, CircularProgress, Grid, TextField } from "@material-ui/core";

import { Modal } from "react-bootstrap";
import "../assets/css/components/confirmationPopup.css";
import useErrors from "../hooks/useErrors";
import { validateGeneric } from "../utils/validations";
import requestAdapter from "../api/request";
import SnackbarContext from "../contexts/Snackbar";
import { useEffect } from "react";
function UpdateTimeCashOutInformation({ onHide, show, client, confirm }) {
  const [loading, setLoading] = useState(false);
  const [hourToCashOut, setHourToCashOut] = useState(client ? client.hourToCashOut : null);
 
  const validations = {
    hourToCashOut: validateGeneric,  
  };
  const [errors, checkFields, canSubmit] = useErrors(validations);
  const { setSnack } = useContext(SnackbarContext);

  useEffect(() => {
    if (show && client) {
      setHourToCashOut(Number(client.hourToCashOut));
    } else {
      setHourToCashOut(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const submit = async () => {
    if (
      canSubmit() &&
      hourToCashOut
    ) {
      setLoading(true);

      try {
        const json = {
          hourToCashOut,
          clientId: client.id,
        };
        await requestAdapter.post("/admin/setTimeCashout", json);
        setLoading(false);
        setSnack({ open: true, message: "Dados atualizados com sucesso!" });
        confirm();
      } catch (error) {
        // values.errorMessage = error.message;
        // values.hasError = true;
        // setValues({ ...values });
        setSnack({ open: true, message: error.message, severity: "error" });
      }

      setLoading(false);
    } else {
      setSnack({
        message: "Preencha corretamente todos os campos",
        open: true,
        severity: "error",
      });
    }
  };

  return (
    <Modal
      show={show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="dialog"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Atualizar Informação da Hora de Transferência
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Informe abaixo a hora, entre 0 e 23, que deseja que seja realizado a transfêrencia automática.
          
        </p>
        <form
          onSubmit={(ev) => {
            ev.preventDefault();
            submit();
          }}
          className="formContent"
        >
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
            <TextField
                fullWidth
                type="number"
                value={hourToCashOut}
                onChange={(ev) => setHourToCashOut(ev.target.value)}
                variant="outlined"
                name="hourToCashOut"
                label="Hora desejada"
                disabled={loading}
                required
                error={!errors.hourToCashOut.valid}
                helperText={errors.hourToCashOut.text}
                onBlur={checkFields}
              />
            </Grid>
            {loading && (
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Grid item xs={12} style={{ marginTop: "20px" }}>
                  <CircularProgress></CircularProgress>
                </Grid>
              </Grid>
            )}
          </Grid>
        </form>
        <p style={{ fontSize: 12, textAlign: "center", marginTop: 5 }}>
          * Lembre-se, a transferência será realizada na hora informada e 59 minutos.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={submit} disabled={loading}>
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UpdateTimeCashOutInformation;
